import { takeEvery, select } from 'redux-saga/effects'
import { RECEIVE_FURNITURE } from 'models/actionTypes'
import { getFilterResult } from 'models/furniture/selectors'
import { getFurnitureFilterTrackingInfo } from 'models/tracking/selectors'
import { getSelectedCompositionTrackingRoomInfo } from 'models/compositions/selectors'
import * as tracker from 'utils/tracker'
import { CATEGORY, SUB_CATEGORY } from 'models/tracking/constants'

export function* trackSearchBrowseSaga({ filter }) {
    const filterResult = yield select(getFilterResult)
    const { categoryLabel, subCategoryLabel, filterSource } = yield select(getFurnitureFilterTrackingInfo)
    const roomInfo = yield select(getSelectedCompositionTrackingRoomInfo)
    if (filter) {
        let eventName
        let trackingInfo = null
        if (filter.query) {
            eventName = 'DecorateRoom.Catalog.Search'
            trackingInfo = {
                SearchTerm: filter.query,
                SearchResultCount: filterResult.count,
            }
        } else if (filter.category) {
            eventName = 'DecorateRoom.Catalog.Browse.Select'
            trackingInfo = {
                BrowseCategoryKey: filter.category,
                BrowseCategoryLabel: categoryLabel,
                BrowseSubCategoryKey: filter.subCategory || null,
                BrowseSubCategoryLabel: subCategoryLabel || null,
                BrowseSelected: filter.subCategory ? SUB_CATEGORY : CATEGORY,
                SelectType: filterSource,
            }
        }
        if (trackingInfo) {
            tracker.click(eventName, { ...roomInfo, ...trackingInfo })
        }
    }
}

function* watchTrackSearchBrowseSaga() {
    yield takeEvery(RECEIVE_FURNITURE, trackSearchBrowseSaga)
}

export const trackingSagas = [watchTrackSearchBrowseSaga()]
